module.exports = __webpack_public_path__ + "img/d2c.c6980dc4.jpg";